import { render, staticRenderFns } from "./ChoiceShops.vue?vue&type=template&id=73cb5b27&scoped=true&"
import script from "./ChoiceShops.vue?vue&type=script&lang=ts&"
export * from "./ChoiceShops.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceShops.vue?vue&type=style&index=0&id=73cb5b27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb5b27",
  null
  
)

export default component.exports